import { useMemo } from 'react';
import { useLocalStorageModals } from '../../../../../hooks/useLocalStorageModals';
import { MAIN } from '../../constants/localStates';
import { useAppState, useContent, useOnboarding } from '../../../../../redux/reducer/content';

export default function useMainInfoModals({ main = [], bath = [] } = {}) {
  const state = useAppState();
  const { isBath } = useContent();
  const { mainInfoModalsVisible } = useOnboarding();

  const modals = useMemo(() => {
    if (state !== MAIN || !mainInfoModalsVisible) return [];
    return (isBath ? bath : main).flat(Number.MAX_VALUE).filter(Boolean);
  }, [...main, ...bath, isBath, state, mainInfoModalsVisible]);

  useLocalStorageModals(modals);
}
